import { useTranslations } from 'next-intl';

import { chainlink as IconChainlink } from '@/components/icons/chainlink';
import { chainlinkLabel as IconChainlinkLabel } from '@/components/icons/chainlinkLabel';

interface ChainlinkBannerProps {
  isTooltip?: boolean;
}

const ChainlinkBanner: React.FC<ChainlinkBannerProps> = ({ isTooltip }: ChainlinkBannerProps) => {
  const t = useTranslations('layout.chainlink');

  if (isTooltip) {
    return (
      <div className="flex items-center gap-2">
        <p className="text-sm font-medium text-text-primary">{t('tooltip')}</p>
        <IconChainlinkLabel width={16} height={16} />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 p-2 bg-surface-checkbox border border-border-primary rounded-lg">
      <IconChainlinkLabel />
      <div className="flex flex-col gap-0.5">
        <p className="text-[10px] font-medium text-text-primary">{t('providedBy')}</p>
        <IconChainlink className="text-text-primary" />
      </div>
    </div>
  );
};

export default ChainlinkBanner;
